module.exports = __webpack_public_path__ + "static/media/atom-alt.c9653404.svg";